import axios from "axios";
// import Vue from 'vue'
import { Message } from "element-ui";
import Router from "@/router";
// import { LoadingBar } from 'iview';
//判断环境变量   https://duv.net.cn   http://10.200.160.248:80/dep/   https://t.dep.xinchao.com https://dep.xinchao.com/dep/  https://https-nginx-tomcat.com/dep/
// let baseURL=process.env.NODE_ENV === 'development'?'https://t.dep.xinchao.com/dep/':'https://t.dep.xinchao.com/dep/';//普通https请求
var isDep = 2; // 0 联调 1测试 2正式
let baseURL;
let socketUrl;
var setTimeOver = null;

switch (isDep) {
  case 0:
    baseURL = "https://t.dep.xinchao.com/dep/";
    socketUrl = "https://t.dep.xinchao.com/";
    break;
  case 1:
    baseURL = "https://t-tdashi.xinchao.com/dep/";
    socketUrl = "https://t-tdashi.xinchao.com";
    break;
  case 2:
    baseURL = "https://dep.xinchao.com/dep/";
    socketUrl = "https://dep.xinchao.com";
    break;

  default:
    break;
}
// let baseURL = isDep
//   ? "https://t.dep.xinchao.com/dep/"
//   : "https://t.tdashi.xinchao.com/dep/"; //普通https请求  测试
// let baseURL=isDep?'https://dep.xinchao.com/dep/':'https://t.tdashi.xinchao.com/dep/';//普通https请求

// vue.$store.dispatch('setBaseUrl',baseURL)
// let baseURL='https://192.168.1.224:80/dep/';//普通https请求

// let socketUrl = isDep
//   ? "https://t.dep.xinchao.com/"
//   : "https://t.tdashi.xinchao.com"; //长连接  测试
// let socketUrl=process.env.NODE_ENV === 'development'?'https://t.dep.xinchao.com/':'https://t.dep.xinchao.com/'; //长连接
axios.defaults.withCredentials = true; //设置跨域使用的  允许跨域携带cookie信息 否则默认不携带cookie
// 设置请求接口到vuex
// 添加请求拦截器
axios.interceptors.request.use(
  function(config) {
    // 在发送请求之前做些什么
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function(response) {
    console.log(response);
    // 对响应数据做点什么
    if (response.status === 200) {
      // 成功
      if (response.data.code == 401) {
        Router.push({ path: "/" });
      }
    }
    return response;
  },
  function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

function success(response) {
  //成功之后的回调
  if (response.data.code === 200 || response.data.code === 0) {
    //成功结果代码
    // LoadingBar.finish();
    // Message({
    //       showClose: true,
    //       message: response.data.msg,
    //       type: 'success'
    // });
    // router.push({path:'/login'})
    return response;
  } else if (response.data.code == 401) {
    // LoadingBar.error();
    return response;
  } else {
    Message({
      showClose: true,
      message: response.data.msg,
      type: "error"
    });
    return response;
  }
}
function error(response) {
  //失败后的回调
  // 隐藏loading
  // 如果http状态码正常，则直接返回数据
  // LoadingBar.error();
  if (
    response &&
    (response.status === 200 ||
      response.status === 304 ||
      response.status === 400)
  ) {
    // 如果不需要除了data之外的数据，可以直接 return response.data
    return response;
  } else {
    // Message({
    //       showClose: true,
    //       message: response.data.msg,
    //       type: 'error'
    // });
  }
}
function httpsAxios(method, url, params, configType) {
  let paramsData = null;
  if (method === "POST" && configType != "fromData") {
    paramsData = JSON.stringify(params);
  } else {
    paramsData = params;
  }
  let data = {
    method: method,
    url: url,
    params: method === "GET" || method === "DELETE" ? paramsData : null,
    data: method === "POST" || method === "PUT" ? paramsData : null, //JSON.stringify(params)
    responseType: configType === "blob" ? "blob" : "json",
    baseURL: baseURL,
    headers: {
      "Content-Type":
        configType === "fromData" ? "multipart/form-data" : "application/json"
      //   'Authorization':Authorization?Authorization:''
    },
    //超时限制
    timeout: configType === "fromData" ? 60000 : 30000
  };
  if (setTimeOver) {
    clearTimeout(setTimeOver); //清除timeout定时器
  }
  setTimeOver = setTimeout(function() {
    console.log("超时执行");
    Router.push({ path: "/" });
  }, 3600000);

  // LoadingBar.start()
  return new Promise((resolve, reject) => {
    axios(data)
      // 此处的.then属于axios
      .then(res => {
        success(res);
        resolve(res);
      })
      .catch(response => {
        error(response);
        resolve(response);
      });
  });
}
// 输出函数getAxios、postAxios、putAxios、delectAxios，供其他文件调用-----------------------------
// Vue.js的插件应当有一个公开方法 install。这个方法的第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象。
function install(Vue) {
  Vue.prototype.httpsAxios = (method, url, params, configType) =>
    httpsAxios(method, url, params, configType);
}
export {
  install,
  baseURL, //后台需要，前端手动拼接域名
  socketUrl
};



// WEBPACK FOOTER //
// ./src/axios/https.js